
<template>
  <div>
    <template v-if="!wapShow">
    <header1 :menuIndex="5"></header1>
    <div class="news-detail-box">
      <div class="app-content flex-sp">
        <div class="detail-left"  >
          <div class="detail-left-title">{{obj.title}}</div>
          <div class="detail-left-date">发布于:{{obj.publishDate}}</div>
          <div v-html="obj.content"></div>
        </div>
        <div class="detail-right">
          <div class="right-t1">最新文章</div>
          <div style="margin-top: 40px">
            <div class="right-t2" v-for="item in list1" @click="toPage(item)">
              <div class="p1">{{item.title}}</div>
              <div  class="p2">{{item.publishDate}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
      <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>

  </div>
</template>


<script type="text/javascript">

  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import axios from "axios";
  import page from "@/components/page"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../news/wapDetail";
  export default {
    name: 'news',
    components:{header1,footers,page,wapIndex},
    data(){
      return{
        id:"",
        obj:{},
        list1:[],
        wapShow:false
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.id = this.$route.query.id;
          this.getNewsList();
          this.getNewsDetail()
        }
      })

    },
    methods:{
      getNewsDetail(){
        axios.get(this.pageUrl+`/news/${this.id}`).then(res=>{
          this.obj=res.data.data;
        })
      },
      toPage(data){
        if(data.type=='outer'){
          window.open(data.url)
        }else if(data.type=='inner'){
          this.id = data.id;
          this.getNewsDetail()
        }
      },
      getNewsList(){
        axios.get(this.pageUrl+`/news/page?pageNo=1&pageSize=6`).then(res=>{
          this.list1 = res.data.data.list;
        })
      }
    }

  }
</script>
<style>
  .detail-left img{
    width: 100%;
  }
</style>
<style scoped>

  .news-detail-box{
    min-height: 500px;
    margin-top: 80px;
    padding-top: 80px;
  }

  .detail-box{
    width: 60%;
  }
  .detail-left{
    width: 740px;
  }

  .detail-left-title{
    text-align: left;
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
  }

  .detail-left-date{
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    text-align: left;
    padding: 23px 0;
    border-bottom: 1px solid #5C5D5F;
    margin-bottom: 24px;
  }
  .detail-right{
    width: 340px;
    background: #F1F3F9;
    border-radius: 4px 4px 4px 4px;
    padding: 40px;
    box-sizing: border-box;
  }
  .detail-right .right-t1{
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }
  .detail-right .right-t2{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
    padding-top: 16px;
    border-top: 1px solid #5C5D5F;
    margin-bottom: 16px;
  }
  .detail-right .right-t2 .p1{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
    height: 45px;
    color: #19203B;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .detail-right .right-t2 .p1:hover{
    color: #0071EF;
    cursor: pointer;
  }
  .detail-right .right-t2 .p2{
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/detail.vue